import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { UploadFile } from "@angular-ex/uploader";
import { UploaderAcceptFormat } from "../../../../../shared/components/file-uploader/file-uploader.component";
import { LinkedInImageUploadMaxFileSize } from "../../../../../shared/defaults/file-uploader-max-file-size";
import {
  LinkedInPostContentType,
  PostPlatform,
} from "../../../../../shared/enums/campaignPost.enums";
import { BrandCampaignAddContentDialogData } from "../../../../../shared/models/brand-campaign-add-content-dialog-data";
import { BrandCampaignLinkedInPost } from "../../../../../shared/models/brandCampaignLinkedInPost";
import { AppDataService } from "../../../../../shared/services/api/app-data.service";
import { DialogService } from "../../../../../shared/services/dialog.service";
import { NotificationService } from "../../../../../shared/services/notification.service";
import { BrandCampaignPostService } from "../../../shared/services/brand-campaign-post.service";
import {
  LinkedinPostCreationBaseDialogComponent,
  LinkedInPostUploadData,
} from "../linkedin-post-creation-base-dialog.component";
import { AnyToImageEntityMapper } from "../../../../../shared/mappers/image.entity.mapper";

export interface LinkedinImagePostCreationDialogData
  extends BrandCampaignAddContentDialogData {
  readonly contentType?: LinkedInPostContentType;
  readonly post?: BrandCampaignLinkedInPost;
}

export type LinkedinImagePostCreationDialogResult = undefined;

@Component({
  selector: "app-linkedin-image-post-creation-dialog",
  templateUrl: "./linkedin-image-post-creation-dialog.component.html",
  styleUrls: [
    "./linkedin-image-post-creation-dialog.component.scss",
    "../../campaign-content-creation-dialog.scss",
  ],
})
export class LinkedinImagePostCreationDialogComponent extends LinkedinPostCreationBaseDialogComponent {
  public readonly uploaderMimeTypes = "jpg, jpeg, png";
  public readonly uploadData: LinkedInPostUploadData;
  public readonly MAX_FILE_SIZE = LinkedInImageUploadMaxFileSize;
  public readonly fileUploaderResponseMapper = AnyToImageEntityMapper;
  protected postType = LinkedInPostContentType.Image;
  public readonly uploaderUrl: string;
  public acceptFormat = UploaderAcceptFormat.Image;
  public currentFile?: File;

  constructor(
    protected readonly translateService: TranslateService,
    protected readonly brandCampaignPostService: BrandCampaignPostService,
    protected readonly notificationService: NotificationService,
    protected readonly dialogRef: MatDialogRef<
      LinkedinImagePostCreationDialogComponent,
      LinkedinImagePostCreationDialogResult
    >,
    protected readonly dialogService: DialogService,
    protected readonly dialog: MatDialog,
    protected readonly appDataService: AppDataService,
    @Inject(MAT_DIALOG_DATA) data: LinkedinImagePostCreationDialogData,
  ) {
    super(
      brandCampaignPostService,
      dialogRef,
      dialogService,
      notificationService,
      translateService,
      dialog,
      appDataService,
      data,
    );

    // If it's an edit post type video, gif or image we just update the current post image
    this.uploaderUrl =
      this.brandCampaignPostService.getAddCampaignDetailCategoryPostFileUrl(
        this.campaign.id,
        this.campaignDetails.id,
        this.category.id,
      );

    this.uploadData = {
      media_type: this.postType,
      platform: PostPlatform.LinkedIn,
    };

    if (this.post?.id) {
      this.uploadData.post_id = this.post.id.toString();
    }
  }

  public textChanged(text: string): void {
    this.post.text = text;
    this.checkSaveDisabled();
  }

  public checkSaveDisabled(): void {
    if (!this.post.image || !this.post.text || this.isSaving) {
      this.isSaveDisabled = true;
      return;
    }

    super.checkSaveDisabled();
  }

  public fileAddedToQueue(file: UploadFile): void {
    this.currentFile = file.nativeFile;
    this.checkSaveDisabled();
  }
}
